import { useQuery } from "@tanstack/react-query";
import { fetchReadStats } from "../lib/fingerspelling-stats-api";

export const READ_STATS_QUERY_KEY = ["fingerspelling-read-stats"] as const;

/** 「よむ」の文字別記録。開始画面を開くたびに取り直す */
export const useReadStats = () => {
  const query = useQuery({
    queryKey: READ_STATS_QUERY_KEY,
    queryFn: fetchReadStats,
    refetchOnMount: "always",
    retry: false,
  });
  // 取り直している間は、前の記録が残っていても「読み込み中」にする（古い苦手で始めさせない）
  const status = query.isFetching
    ? "loading"
    : query.isError || query.data === undefined
      ? "error"
      : "ready";
  return { stats: query.data, status, refetch: query.refetch } as const;
};
